import React, { ChangeEvent } from 'react';
import styled from '@emotion/styled';
import { InputLabel, ListItemText, Radio, RadioGroup } from '@mui/material';
import debounce from 'lodash/debounce';
import { GroupsSelectInterface, OptionSelectionInterface } from '../Filter.interface';
import {
  FilterChildNameSharedStyle,
  FilterChildSharedStyle,
  FilterDelay,
  RadioCellStyle,
  RadioComponentStyle,
  RadioLabelStyle,
  TableContainerStyle,
} from '../Filter.mock';

const TableContainer = styled.div(TableContainerStyle, FilterChildSharedStyle);

const RadioGroupSelection = ({ groupName, checkedEntity, onChangeHandler, totalEntities }: GroupsSelectInterface & OptionSelectionInterface) => {
  const handledCheckedValue = Object.values(checkedEntity);

  const onSelectHandler = debounce((event: ChangeEvent<HTMLInputElement>) => {
    event.preventDefault();
    const { value } = event.target as HTMLInputElement;

    if (!handledCheckedValue.includes(value)) onChangeHandler(value);
  }, FilterDelay);

  return (
    <TableContainer>
      <InputLabel sx={FilterChildNameSharedStyle}>
        <b>{groupName}</b>
      </InputLabel>
      <RadioGroup row value={handledCheckedValue} onChange={onSelectHandler}>
        {totalEntities.map(({ code, display }) => (
          <li key={code} style={RadioCellStyle}>
            <Radio value={code} sx={RadioComponentStyle} />
            <ListItemText sx={RadioLabelStyle} primary={display} />
          </li>
        ))}
      </RadioGroup>
    </TableContainer>
  );
};

export default RadioGroupSelection;
